import React, { PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import classNames from "classnames";

import { Button } from "./MapButton.styles";

interface MapButtonProps {
  /**
   * Unique identifier for this button.
   */
  id: string;
  /**
   * Tooltip title for this button.
   */
  title: string;
  /**
   * A data-testid for this button.
   */
  dataT: string;
  /**
   * Called when the button is clicked.
   */
  onClick: () => void;
  /**
   * Whether the button is clicked down (default: false).
   */
  active?: boolean;
  /**
   * Whether the button is clickable (default: true).
   */
  enabled?: boolean;
}

const MapButton: React.FC<PropsWithChildren<MapButtonProps>> = ({ active, enabled, id, title, dataT, onClick, children }) => {
  return (
    <Box key={id} style={{ flex: "0 1 1" }}>
      <Tooltip title={title} placement="left">
        <span>
          <Button
            aria-label={title}
            variant="contained"
            disabled={!(enabled ?? true)}
            onClick={onClick}
            data-testid={dataT}
            className={classNames({ active: active ?? false })}
          >
            {children}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default MapButton;
